import React from 'react';
import { useStyletron } from 'baseui';
import Icons from '../icons';

interface TitleProps {
  title: string | React.ReactNode;
  handleModalClose?: () => void;
  showClose?: boolean;
}

export const ModalTitle = ({
  title,
  handleModalClose,
  showClose = true,
}: TitleProps) => {
  const [, theme] = useStyletron();
  return (
    <div
      style={{
        borderTopLeftRadius: theme.borders.radius300,
        borderTopRightRadius: theme.borders.radius300,
      }}
      className="flex w-full items-center justify-between bg-['#1D2939'] p-3"
    >
      <div className='text-lg text-white'>{title}</div>
      {showClose && (
        <div className='cursor-pointer' onClick={handleModalClose}>
          <Icons icon={'close'} fillColor={theme.colors.white} />
        </div>
      )}
    </div>
  );
};
